import { useState } from 'react';

import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ReactComponent as LiveIcon } from 'assets/icons/live-class.svg';
import Drawer from 'components/Drawer/Drawer';

import DrawerNotes from './components/DrawerNotes/DrawerNotes';
import './Controls.scss';
import { useAppSelector } from '../../../../../../redux/hooks';

import { getUser } from 'redux/authentication/auth.slice';

import userAvatar from '../../../../../../assets/avatar.jpg';
import UseLiveClassDetails from '../../../../../../hooks/useLiveClassDetails';
import Students from '../Students/Students';

const Controls = ({ match }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [toggleModal] = useState(false);
  const user = useAppSelector(getUser);
  const { endVideo } = UseLiveClassDetails();
  const { t } = useTranslation('live_classes');

  // const handleLiveVideo = () => {
  //     history.push('/live/video');
  // };
  //
  // const handleAddNotes = () => {
  //     setDrawerOpen(true);
  // };

  return (
    <div className="live-class-footer">
      <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <DrawerNotes />
      </Drawer>

      <div className="profile-image">
        <img alt="" src={userAvatar} />
      </div>

      <div className="controls-container">
        <div className="live-person-info">
          {/* <Avatar src="https://media.istockphoto.com/photos/portrait-of-handsome-latino-african-man-picture-id1007763808?k=6&m=1007763808&s=612x612&w=0&h=Js1VDBulbaNw_CF7fghP_nhUPCC-DQTqb7Wym1CdTOI=" /> */}
          <p>{`${user.first_name} ${user.last_name}`}</p>
          <LiveIcon className="live-icon" />
          <p className="live">{t('live')}</p>
        </div>

        {/* <button> */}
        {/*    <RecordIcon/> */}
        {/*    <p>Record this class</p> */}
        {/* </button> */}

        {/* <button> */}
        {/*    <HandIcon/> */}
        {/*    <p>Ask a question</p> */}
        {/* </button> */}

        {/* {user.role === 'teacher' && (
          <button className="upload-notes" onClick={() => setToggleModal(state => !state)}>
            <p>{t('Attendees')}</p>
          </button>
        )} */}

        <button className="leave-button" onClick={() => endVideo(match.params.id)}>
          <p>{t('LiveClass')}</p>
        </button>
      </div>
      <Students toggleModal={toggleModal} liveClassId={match.params.id} />
    </div>
  );
};

export default withRouter(Controls);
